// @flow

export default [
  {
    "tagName": "div",
    "attributes": [
      {
        "name": "class",
        "value": "wp-block-ffrblocks-find-club"
      }
    ],
    "children": [
      {
        "tagName": "div",
        "attributes": [
          {
            "name": "class",
            "value": "box card card--find "
          }
        ],
        "children": [
          {
            "tagName": "div",
            "attributes": [
              {
                "name": "class",
                "value": "card__thumbnail img-green"
              }
            ],
            "type": "element"
          },
          {
            "tagName": "div",
            "attributes": [
              {
                "name": "class",
                "value": "card__body"
              }
            ],
            "children": [
              {
                "tagName": "h2",
                "attributes": [
                  {
                    "name": "class",
                    "value": "card__title"
                  }
                ],
                "children": [
                  {
                    "type": "text",
                    "text": "Trouver un club"
                  }
                ],
                "type": "element"
              },
              {
                "tagName": "p",
                "attributes": [
                  {
                    "name": "class",
                    "value": "card__desc"
                  }
                ],
                "children": [
                  {
                    "type": "text",
                    "text": "Retrouvez les clubs les plus proches de chez vous, filtrés par pratique, nombre de licenciés, horaires, compétitions et apprenez en plus sur votre futur club !"
                  }
                ],
                "type": "element"
              }
            ],
            "type": "element"
          },
          {
            "tagName": "div",
            "attributes": [
              {
                "name": "class",
                "value": "card__footer"
              }
            ],
            "children": [
              {
                "tagName": "a",
                "attributes": [
                  {
                    "name": "to",
                    "value": "#"
                  },
                  {
                    "name": "class",
                    "value": "btn btn--white btn--full"
                  }
                ],
                "children": [
                  {
                    "tagName": "i",
                    "attributes": [
                      {
                        "name": "class",
                        "value": "icon icon-geoloc is-inline"
                      }
                    ],
                    "type": "element"
                  },
                  {
                    "tagName": "span",
                    "attributes": [],
                    "children": [
                      {
                        "type": "text",
                        "text": "Trouver un club"
                      }
                    ],
                    "type": "element"
                  }
                ],
                "type": "element"
              }
            ],
            "type": "element"
          }
        ],
        "type": "element"
      }
    ],
    "type": "element"
  }
];
